import { Component } from 'react'

/**
 * Last-resort error boundary. Wraps the whole app tree so a single broken
 * component doesn't take the page to white. Replace the fallback UI with a
 * proper error page once one exists.
 */
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, info) {
    // Hook up to your error tracker (Sentry, etc.) here.
    console.error('[ErrorBoundary]', error, info?.componentStack)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-sand p-6">
          <div className="max-w-md rounded-2xl bg-white p-8 text-center shadow-card">
            <h1 className="mb-2 text-2xl font-bold text-charcoal">Something went wrong</h1>
            <p className="mb-6 text-sm text-charcoal-600">
              We hit an unexpected error. Try refreshing the page.
            </p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="rounded-full bg-coral px-6 py-2 text-sm font-semibold text-white shadow-card hover:bg-coral-500"
            >
              Refresh
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
